import { render } from "./ProposalSavedDraftModal.vue?vue&type=template&id=3e6cd8d0"
import script from "./ProposalSavedDraftModal.vue?vue&type=script&lang=js"
export * from "./ProposalSavedDraftModal.vue?vue&type=script&lang=js"

import "./ProposalSavedDraftModal.vue?vue&type=style&index=0&id=3e6cd8d0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__